import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IDropdown, IPickupLocation } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./PickUpLocation";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {
    const [hotels, setHotels] = useState<IDropdown[]>();
    const [hotelId, setHotelId] = useState(0);
    const [cities, setCities] = useState<IDropdown[]>();
    const [selectedCity, setSelectedCity] = useState<IDropdown>();
    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: IPickupLocation[], count: number, loading: boolean });
    const [text, setText] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    useEffect(() => {
        if (hotelId) loadTableData(hotelId);
    }, [hotelId, text, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadHotels = async (cityId: number) => {
        const response = await Fetch(`hotel/dropdown/${cityId}`, "GET", null, null, null);
        if (response) {
            setHotels(await response.json());
        }
    }

    useEffect(() => {
        if (selectedCity?.id) loadHotels(selectedCity.id);
    }, [selectedCity])

    const loadTableData = async (hotelId: number) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`pickuplocation/${hotelId}`, "GET", null, `lazyParams=${JSON.stringify(lazyParams)}${text ? '&text=' + text : ''}`, props.toast);
        if (response) {
            const data: { pickupLocations: IPickupLocation[], count: number } = await response.json();
            setTableData({ data: data.pickupLocations, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        if (hotelId) props.setModal({ open: true, singleData: { isActive: true, hotelId: hotelId } });
    };

    const openEdit = (rowDatauser: IPickupLocation) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const Remove = async (rowData: IPickupLocation) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`pickuplocation/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Pickup Location Deleted", life: 3000 });
            if (hotelId) loadTableData(hotelId);
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: IPickupLocation) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.name}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    async function onCitySearch(text: string) {
        const response = await Fetch(`city/search`, "GET", null, `text=${text}`, null);
        if (response) {
            setCities(await response.json());
        }
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {props.hasPermission("PickupLocation", "Add") && (
                    <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} />
                )}
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Pickup Locations</h4>
                    <span style={{ margin: '0 10px' }} >City : </span>
                    <AutoComplete field="name" value={selectedCity} suggestions={cities} completeMethod={(e) => onCitySearch(e.query)} onChange={(e) => setSelectedCity(e.value)} />
                    <span style={{ margin: '0 10px' }} >Hotel : </span>
                    <Dropdown value={hotelId} onChange={(e) => { setHotelId(e.value) }} options={hotels} optionLabel="name" optionValue="id" />
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
                {props.hasPermission("PickupLocation", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );


    const actionBodyTemplate = (rowData: IPickupLocation) => {
        return (
            <div className="actions">
                {props.hasPermission("PickupLocation", "Edit") && <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />}
                {props.hasPermission("PickupLocation", "Remove") && <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }}  ></Button>}
            </div>
        );
    };

    const statusBody = (rowData: IPickupLocation) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className={`pi ${rowData.isActive ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.isActive ? '#4caf50' : '#f44336' }}></i>
                <span>{rowData.isActive ? 'Active' : 'Disable'}</span>
            </div>
        );
    }

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                {/* <Column field="id" header="ID" sortable /> */}
                <Column field="name" header="Pickup Location" sortable />
                <Column field="distance" header="Distance(Km)" sortable />
                <Column field="noOfTols" header="No Of Tols" sortable />
                <Column field="tollCharge" header="Toll Charge" sortable />
                <Column field="parkingCharge" header="Parking Charge" sortable />
                <Column field="isActive" header="Status" sortable body={statusBody} />
                {/* <Column field="desc" header="Desc" /> */}
                <Column body={actionBodyTemplate} />
            </DataTable>
            <ConfirmDialog />
        </>
    );
}
